import * as React from 'react'
import styled from 'styled-components'

import * as CM from './styles'

export interface FileItemProps extends Pick<React.CSSProperties, 'aspectRatio' | 'objectFit'> {
    noLazy?: boolean
    src?: string
    alt?: string
    title?: string
    onClick?: React.MouseEventHandler<HTMLImageElement>
    style?: React.CSSProperties
}

const SCxImage = styled(CM.MImage)`
    transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    z-index: 2;
`

const FileItem: React.FunctionComponent<FileItemProps> = ({ onClick, noLazy, src, aspectRatio, style, ...rest }) => {
    return (
        <SCxImage
            {...rest}
            src={src}
            loading={noLazy ? undefined : 'lazy'}
            onClick={onClick}
            aspectRatio={aspectRatio}
            style={{
                width: '100%',
                height: '100%',
                ...style
            }}
        />
    )
}

export default FileItem
